/**
 * FIXME: We initially used this as a single source of truth, but other places has unique ACP objects.
 * Such as Edit Service ACP, it separates from this.
 * Check if we can refactor to make it use this.
 */

import { AverageLengthOfEmploymentTooltip } from "@/components/shared/CustomTooltips";

/**
 * Configuration for advanced cost parameters used across multiple components.
 * This provides a single source of truth for form field definitions.
 */

export interface AdvancedCostParameterConfig {
  /** The field name used in forms */
  name: string;
  /** Translation key for the field label */
  labelKey: string;
  /** Translation key for the field placeholder */
  placeholderKey: string;
  /** Whether the field accepts only integer values */
  isInteger?: boolean;
  /** Display style for the field */
  style?: "decimal" | "currency";
  /** Tooltip text for the field */
  tooltip?: string;
  /** Custom tooltip component for the field */
  customTooltip?: React.ReactNode;
  /** Class name for the tooltip trigger */
  tooltipTriggerClassName?: string;
}

/**
 * Shared configuration for all advanced cost parameter form fields.
 * Used by both organization creation and settings components.
 */
export const ADVANCED_COST_PARAMETERS_CONFIG: AdvancedCostParameterConfig[] = [
  {
    name: "averageHoursWorkedPerMonth",
    labelKey: "translation:settings.advancedcosts.inputs.averagehoursworkedpermonth.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.averagehoursworkedpermonth.placeholder",
    isInteger: true,
    style: "decimal",
  },
  {
    name: "trainingDays",
    labelKey: "translation:settings.advancedcosts.inputs.trainingdays.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.trainingdays.placeholder",
    isInteger: true,
    style: "decimal",
  },
  {
    name: "yearlyTrainingCosts",
    labelKey: "translation:settings.advancedcosts.inputs.yearlytrainingcosts.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.yearlytrainingcosts.placeholder",
    isInteger: false,
    style: "currency",
  },
  {
    name: "sickDays",
    labelKey: "translation:settings.advancedcosts.inputs.sickdays.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.sickdays.placeholder",
    isInteger: true,
    style: "decimal",
  },
  {
    name: "employeeFluctuation",
    labelKey: "translation:settings.advancedcosts.inputs.employeefluctuation.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.employeefluctuation.placeholder",
    isInteger: false,
    style: "decimal",
  },
  {
    name: "yearlyUniformCosts",
    labelKey: "translation:settings.advancedcosts.inputs.yearlyuniformcosts.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.yearlyuniformcosts.placeholder",
    isInteger: false,
    style: "currency",
  },
  {
    name: "otherMaterialCosts",
    labelKey: "translation:settings.advancedcosts.inputs.othermaterialcosts.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.othermaterialcosts.placeholder",
    isInteger: false,
    style: "currency",
  },
  {
    name: "averageLengthOfEmployment",
    labelKey: "translation:settings.advancedcosts.inputs.averagelengthofemployment.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.averagelengthofemployment.placeholder",
    isInteger: true,
    style: "decimal",
    customTooltip: <AverageLengthOfEmploymentTooltip />,
    tooltipTriggerClassName: "text-orange-500"
  },
  {
    name: "carCostsPerMinute",
    labelKey: "translation:settings.advancedcosts.inputs.carcostsperminute.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.carcostsperminute.placeholder",
    isInteger: false,
    style: "currency",
  },
  {
    name: "otherCostsPerMinute",
    labelKey: "translation:settings.advancedcosts.inputs.othercostsperminute.label",
    placeholderKey: "translation:settings.advancedcosts.inputs.othercostsperminute.placeholder",
    isInteger: false,
    style: "currency",
  },
];
